export default {
    getSyarat: (state: any): any => state.syarat,
    getJenis: (state: any): any => state.jenis,
};